/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
import * as H from 'history'
import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { MilestoneReportController } from '../../controllers/MilestoneReportController'
import { MilestoneModel } from '../../models/MilestoneModel'
import { MilestoneReportModel } from '../../models/MilestoneReportModel'
// import { Consultant } from '../../models/Consultant'
// import { Option } from '../../shared/fields/Options'
import { ISupportSpinner } from '../../shared/Ajax'
import { Backdrop } from '../../shared/Backdrop'
import { TimeoutPopup } from '../../shared/TimeoutPopup'
import ApplicationSummary from './ApplicationSummary'
import { Expenditure } from './Expenditure'
import { ExportEarning } from './ExportEarning'
import { GeneralRequirement } from './GeneralRequirement/index'
import { ReportFinalisation } from './ReportFinalisation'
import { OverseasRepresentativePage } from './Expenditure/otherTables/OverseasRepresentative/OverseasRepresentativePage'
import { MilestoneConsultantPage } from './Expenditure/otherTables/MilestoneConsultant/MilestoneConsultantPage'
import { documentTypeInfo } from './documents/DocumentTypeInfo'
import { MilestoneDocumentUploadPage } from './documents/DocumentUploadPage'
import { MilestoneReportDocumentModel } from '../../models/MilestoneReportDocumentModel'
import { MilestoneSubmissionPage } from './MilestoneSubmissionPage'
import { MilestoneReportPreviewPage } from './PreviewPage'

export interface Props {
    history: H.History
    location: H.Location
    milestoneID: string
}

export interface State {
    loading: boolean
    readOnly: boolean
    model: MilestoneReportModel // this contains markets, marketRegions, addressCountries
    autoMilestoneReportIdentifier: string
    // TODO: remove following 3 items, it is never set !
    // addressCountries: Option<string>[]
    // markets: Option<string>[] //{value:string;label:string;}[]
    // marketRegions: string[]
    autoLogout: boolean
    showPdfContent: boolean
    uploadedDocuments: MilestoneReportDocumentModel[]
}

interface Tab {
    link: string,
    text: string
}

const milestoneReportTabs: Tab[] = [
    {
        link: 'generalRequirement',
        text: 'General requirement',
    },
    {
        link: 'expenditure',
        text: 'Activities and Expenditure',
    },
    {
        link: 'exportEarning',
        text: 'Export earning',
    },
    {
        link: 'reportFinalisation',
        text: 'Report finalisation',
    },
]

class MilestoneReportIndex extends React.Component<Props, State> implements ISupportSpinner {
    ajax: MilestoneReportController;
    previewForm: HTMLFormElement;
    previewInput: HTMLInputElement;
    previewContent: HTMLDivElement;

    constructor(props: Props) {
        super(props)

        this.ajax = new MilestoneReportController()

        this.state = {
            loading: false,
            readOnly: false,
            model: null,
            autoMilestoneReportIdentifier: '',
            autoLogout: false,
            showPdfContent: false,
            uploadedDocuments: [],
            // addressCountries: [],
            // markets: [],
            // marketRegions: []
        }
    }

    componentDidMount() {
        const { autoLogout } = this.state
        window.onbeforeunload = () => {
            if (!autoLogout) return 'Changes you made may not be saved.'
        }
        this.load()
    }

    componentDidUpdate(prevProps: Props, prevState: State) {
        const { milestoneID, location } = this.props
        const { model } = this.state

        if (milestoneID !== prevProps.milestoneID || (model && model.milestoneModel.milestoneReportID !== milestoneID)) {
            this.load()
        } else if (location.pathname !== prevProps.location.pathname) {
            let { lastValidPage } = model.milestoneModel
            if (this.getTabIndex(location.pathname) >= this.getTabIndex(lastValidPage)) {
                lastValidPage = location.pathname
            }
            this.setState({
                model: { ...model, milestoneModel: { ...model.milestoneModel, currentPage: location.pathname, lastValidPage } },
            })
        }
    }

    componentWillUnmount() {
        window.onbeforeunload = null
        this.ajax.cancel()
    }

    onAutoLogout = () => {
        this.setState({ autoLogout: true })
    }

    getTabIndex = (url: string) => {
        if (url) {
            if (url.indexOf('/reportFinalisation') >= 0) return 3

            for (let i = 0; i < milestoneReportTabs.length; i++) {
                if (url.toLowerCase().indexOf(milestoneReportTabs[i].link.toLowerCase()) >= 0) {
                    return i
                }
            }
        }
        return 0
    }

    getTab = (url: string) => milestoneReportTabs[this.getTabIndex(url)]

    load = () => {
        const { milestoneID, history } = this.props
        this.ajax.getMilestoneReportData(this, milestoneID, (model: MilestoneReportModel) => {
            this.setState({ model }, () => {
                if (model) {
                    const tab = this.getTab(model.milestoneModel.currentPage)
                    history.replace(`/milestone-report/${milestoneID}/${tab.link}`)
                    this.setState({ model: { ...this.state.model, milestoneModel: { ...this.state.model.milestoneModel, milestoneReportDocuments: model.uploadedDocuments } } }
                        , () => {
                            const tab = this.getTab(model.milestoneModel.currentPage)
                            history.replace(`/milestone-report/${milestoneID}/${tab.link}`)
                    })
                }
            })
        })
    }

    navigate = (tabIndex: number) => {
        const { model } = this.state
        const { history, milestoneID } = this.props
        const lastValidTabIndex = this.getTabIndex(model.milestoneModel.lastValidPage)
        if (tabIndex > lastValidTabIndex) {
            alert("Please use 'Save & Next' button to navigate to the tab")
            return
        }
        history.push(`/milestone-report/${milestoneID}/${milestoneReportTabs[tabIndex].link}`)
    }

    saveAndExit = (e: React.MouseEvent) => {
        e.preventDefault()

        const { model: { milestoneModel } } = this.state
        const { history } = this.props
        this.ajax.saveMilestoneReport(this, milestoneModel, () => {
            history.push('/')
        })
    }

    save = (e: React.MouseEvent) => {
        e.preventDefault()
        const { model: { milestoneModel } } = this.state
        this.ajax.saveMilestoneReport(this,
            milestoneModel,
            (d: MilestoneModel) => {
                const { model } = this.state
                this.setState({ model: { ...model, milestoneModel: { ...model.milestoneModel, ...d } } })
            })
    }

    preview = (e: React.MouseEvent) => {
         e.preventDefault()
         this.setState({ showPdfContent: true }, () => {
           this.previewInput.value = this.previewContent.innerHTML
           this.previewForm.submit()
           this.setState({ showPdfContent: false })
         })
    }

    onChange = (changes: Partial<MilestoneModel>, callback?: { (): any }) => {
        const { model } = this.state
        const { location } = this.props
        this.setState({ model: { ...model, milestoneModel: { ...model.milestoneModel, ...changes, lastValidPage: location.pathname } } }, callback)
    }

    onSubmit = (autoMilestoneReportIdentifier: string, callback?: { (): any }) => {
        this.setState({ autoMilestoneReportIdentifier }, callback)
    }

    toggleSpinner(on: boolean, callback: { (): any }): void {
        this.setState({ loading: on }, callback)
    }

    render() {
        const { model, loading } = this.state
        const { milestoneID, location } = this.props

        if (!model || model.milestoneModel.milestoneReportID !== milestoneID) {
            return <div className="container-fluid mt-2 text-center"><h5>Please wait. Loading...</h5></div>
        }

        const routes = (
            <Switch>
                <Route
                    path="/milestone-report/:id/generalRequirement"
                    exact
                    render={(p) => <GeneralRequirement model={model} onChange={this.onChange} history={p.history} />}
                />
                <Route
                    path="/milestone-report/:id/expenditure"
                    exact
                    render={(p) => <Expenditure model={model} onChange={this.onChange} history={p.history} />}
                />
                <Route
                    path="/milestone-report/:id/expenditure/overseasRepresentative"
                    exact
                    render={(p) => <OverseasRepresentativePage model={model.milestoneModel} onChange={this.onChange} history={p.history} addressCountries={model.addressCountries} />}
                />
                <Route
                    path="/milestone-report/:id/expenditure/milestoneconsultant"
                    exact
                    render={(p) => <MilestoneConsultantPage model={model.milestoneModel} onChange={this.onChange} history={p.history} addressCountries={model.addressCountries} />}
                />
                <Route
                    path="/milestone-report/:id/exportEarning"
                    exact
                    render={(p) => (
                        <ExportEarning
                            model={model}
                            markets={model.markets}
                            marketRegions={model.marketRegions}
                            onChange={this.onChange}
                            history={p.history}
                        />
                        )}
                />
                <Route
                    path="/milestone-report/:id/reportFinalisation"
                    exact
                    render={(p) => <ReportFinalisation model={model} onChange={this.onChange} history={p.history} onSubmit={this.onSubmit} />}
                />
                <Route
                    path="/milestone-report/:id/documents/:code/:item?"
                    render={(p) => (
                        <MilestoneDocumentUploadPage
                            model={model.milestoneModel}
                            code={p.match.params.code}
                            item={p.match.params.item || ''}
                            onChange={this.onChange}
                            history={p.history}
                        />
                    )}
                />

                <Route
                    path="/milestone-report/:id/milestonesubmission"
                    render={(p) => <MilestoneSubmissionPage autoMilestoneReportIdentifier={this.state.autoMilestoneReportIdentifier} history={p.history} />}
                />
            </Switch>
            // removed addressCountries={model.markets} from ReportFinalisation
        )

        // if (this.state.readOnly) {
        //    routes = (
        //        <Switch>
        //            <Route
        //                path="/milestone-report/:id/preview"
        //                exact
        //                render={
        //                    (p) => (
        //                        <PreviewPage
        //                            model={this.state.model}
        //                            onChange={this.onChange}
        //                            onSubmit={this.onSubmit}
        //                            history={p.history}
        //                            onPrint={this.preview}
        //                            addressCountries={this.state.addressCountries}
        //                        />
        //                    )
        //                }
        //            />
        //        </Switch>
        //    )
        // }

        const pdfContent = this.state.showPdfContent
            ? (
                <>
                    <div ref={(r) => this.previewContent = r}>
                        <MilestoneReportPreviewPage
                            model={this.state.model}
                            onChange={this.onChange}
                            onSubmit={this.onSubmit}
                            history={this.props.history}
                            //addressCountries={this.state.addressCountries} //REMOVED, it was not being used.
                        />
                    </div>
                    <form ref={(r) => this.previewForm = r} action="/api/pdf" target="_blank" method="POST" style={{ display: 'none' }}>
                        <input type="hidden" name="content" ref={(r) => this.previewInput = r} />
                        <input type="hidden" name="orgName" value={`${this.state.model.applicationModel.registeredBusinessName} Milestone Report ${this.state.model.grantAgreementDetailModel.reportingPeriod} ${this.state.model.milestoneModel.milestoneIdentifier || ''}`} />
                    </form>
                </>
            )
            : <></>

        const currentTabIndex = this.getTabIndex(location.pathname)
        const lastValidTabIndex = this.getTabIndex(model.milestoneModel.lastValidPage)

        const documents: JSX.Element[] = []

        const preparePart = location.pathname.indexOf('/finalise')
        const previewPage = location.pathname.indexOf('/preview') >= 0
        const submissionPage = location.pathname.indexOf('/milestonesubmission') >= 0

        if (previewPage || submissionPage) {
           return (
             <div className="container-fluid mt-2">
               <div className="row">
                 <div className="col-lg-9">
                    {routes}
                 </div>
               </div>
              {pdfContent} 
               <TimeoutPopup onLogout={this.onAutoLogout} />
             </div>
           )
         }

        if (preparePart < 0) {
            for (const docType of documentTypeInfo) {
                const items = docType.reducer(this.state.model)
                for (const id of items) {
                    if (docType.quickList(this.state.model, id)) {
                        let className = 'todo'
                        if (this.state.model.milestoneModel.milestoneReportDocuments && this.state.model.milestoneModel.milestoneReportDocuments.filter((r) => r.code == docType.code).length > 0) {
                            className = 'done'
                        }
                        documents.push(
                            <li key={`${docType.code}-${id}`}>
                                <a className={className} href="#" onClick={(e) => { e.preventDefault(); this.props.history.push(`/milestone-report/${this.state.model.milestoneModel.milestoneReportID}/documents/${docType.code}/${id}`) }}>
                                    {docType.title}
                                </a>
                            </li>
                        )
                    }
                }
            }
        } else {
            documents.push(
                <li key="more">
                    <a href="#supportingDocumentSection">
                        See Supporting Documentation...
                    </a>
                </li>
            )
        }

        return (
            <div className="container-fluid mt-2 ">
                <div className="row">
                    <div className="col-lg-9">
                        <h2>Milestone Report</h2>
                        <ApplicationSummary
                            model={model.grantAgreementDetailModel}
                        />
                        {milestoneReportTabs.filter((d) => location.pathname.toLowerCase().indexOf(d.link.toLowerCase()) >= 0).map((d, i) => (
                            <div key={i} className="mb-2 aus-tab-header">
                                {d.text}
                            </div>
                        ))}
                        <div className="mb-3 aus-tab-container">
                            {milestoneReportTabs.map((d, i) => (
                                <div
                                    key={i}
                                    className={'aus-tab'
                                        + `${i === currentTabIndex ? ' aus-tab-active' : ''}`
                                        + `${i > lastValidTabIndex ? ' aus-tab-disabled' : ''}`}
                                >
                                    <a id={`tab${d.text}`} className="aus-tab-title" href="#" onClick={(e) => { this.navigate(i); e.preventDefault() }}>{d.text}</a>
                                    <a id={`tab${i + 1}`} className="aus-tab-number" href="#" onClick={(e) => { this.navigate(i); e.preventDefault() }}>{i + 1}</a>
                                </div>
                            ))}
                        </div>
                        {routes}
                    </div>
                    <div className="col-lg-3">
                        <div className="aus-formnav">
                            <div>
                                <ul className="aus-org-name" style={{ marginBottom: '0rem' }}>
                                    <li>
                                        <strong>{model.applicationModel.registeredBusinessName}</strong>
                                    </li>
                                </ul>
                                <ul className="aus-formnav-actions">
                                    <li>
                                        <a href="#" onClick={this.saveAndExit}>
                                            <img src="/images/saveandexit.png" className="mr-2" />
                                            <span className="media-body">Save & Exit</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" onClick={this.save}>
                                            <img src="/images/save.png" className="mr-2" />
                                            <span className="media-body">Save</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" onClick={this.preview}>
                                            <img src="/images/preview.png" className="mr-2" />
                                            <span className="media-body">Preview & Print</span>
                                        </a>
                                    </li>
                                </ul>
                                {documents.length > 0 ? (
                                    <>
                                        <h5>Required documents</h5>
                                        <ul className="aus-formnav-todo">
                                            {documents}
                                        </ul>
                                    </>
                                ) : <></>}
                            </div>
                        </div>
                    </div>
                </div>
                { pdfContent }
                <Backdrop on={loading} />
                <TimeoutPopup onLogout={this.onAutoLogout} />
            </div>
        )
    }
}

export default MilestoneReportIndex
